/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import React from "react";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import App from "./app/App";
import store, { persistor } from "./redux/store";
import "./sass/style.react.rtl.css"; // Standard version
//
// import "./sass/style.react.css"; // Standard version
import "@fortawesome/fontawesome-free/css/all.min.css";
import "socicon/css/socicon.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
// Datepicker
import CacheBuster from "react-cache-buster";
import "react-datepicker/dist/react-datepicker.css";
import { ErrorBoundary } from "react-error-boundary";
import "react-toastify/dist/ReactToastify.css";
import { version } from "../package.json";
import { MetronicI18nProvider } from "./_metronic/i18n";
import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider,
} from "./_metronic/layout";
import "./App.css";
import ExeptionPage from "./app/pages/errorPage/ExeptionPage";
import Loading from "./loading";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
// /* const mock = */ _redux.mockAxios(axios);
/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
// _redux.setupAxios(axios);
let ApiUrl = `${process.env.REACT_APP_API_END_POINT}`;
if (ApiUrl.includes("develop")) {
  ReactDOM.render(
    <MetronicI18nProvider>
      <MetronicLayoutProvider>
        <MetronicSubheaderProvider>
          <MetronicSplashScreenProvider>
            <CacheBuster
              currentVersion={version}
              isEnabled={true} //If false, the library is disabled.
              isVerboseMode={false} //If true, the library writes verbose logs to console.
              loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
              // metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
            >
              <App store={store} persistor={persistor} basename={PUBLIC_URL} />
            </CacheBuster>
          </MetronicSplashScreenProvider>
        </MetronicSubheaderProvider>
      </MetronicLayoutProvider>
    </MetronicI18nProvider>,
    document.getElementById("root")
  );
} else {
  ReactDOM.render(
    <MetronicI18nProvider>
      <MetronicLayoutProvider>
        <MetronicSubheaderProvider>
          <MetronicSplashScreenProvider>
            <ErrorBoundary
              // fallback={<ExeptionPage />}
              FallbackComponent={ExeptionPage}
              onReset={() => {
                // window.location.href = "/welcome";
              }}
              onError={() => {
                // setTimeout(() => {
                //   window.location.href = "/";
                // }, 3000);
              }}
            >
              <CacheBuster
                currentVersion={version}
                isEnabled={true} //If false, the library is disabled.
                isVerboseMode={false} //If true, the library writes verbose logs to console.
                loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
                // metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
              >
                <App
                  store={store}
                  persistor={persistor}
                  basename={PUBLIC_URL}
                />
              </CacheBuster>
            </ErrorBoundary>
          </MetronicSplashScreenProvider>
        </MetronicSubheaderProvider>
      </MetronicLayoutProvider>
    </MetronicI18nProvider>,
    document.getElementById("root")
  );
}
serviceWorkerRegistration.unregister();
